<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rAo3Lj/tc-custom/9781454934721.jpg?1705026902619" alt="This image is the cover for the book Aretha"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Aretha
      </h1>
      <p class="bookDescription body article font2">
        <b>From an award–winning journalist, an illustrated retrospective of Aretha Franklin, celebrating her life, music and legacy. </b><br/><br/>Aretha Franklin’s voice was legendary, unforgettable: deeply rooted in gospel, yet versatile enough to brilliantly interpret R&amp;B, rock, soul, pop, and jazz standards, it fueled a six-decade career. Her vocal wallop was a mix of preaching, rebuke, and elation. From the languorous “I Never Loved a Man (the Way That I Love You),” to the funky “Chain of Fools,” to the fiercely feminist “Think,” to the definitive, demanding version of Otis Redding’s “Respect,” Franklin’s songs played out against the tumultuous sociopolitical backdrop of the late ’60s like a soundtrack meant to set things right. Her accolades were many: she received the Kennedy Center honor in 1994, won 18 Grammys®, was the first woman inducted into the Rock and Roll Hall of Fame, and performed for presidents and the Pope. Illustrated with 85 photos, and with insightful text from noted radio personality and author Meredith Ochs, Aretha explores the diva’s life, from her formative years growing up in Detroit, to her singing and recording career from the 1950s until her untimely death in 2018, to her numerous honors, awards, and causes, including her advocacy for civil rights and the arts.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Meredith Ochs
      </h2>
      
      <p class="authorDescription body article">Longtime NPR commentator Meredith Ochs is an award-winning broadcast journalist, author, musician, and photographer. Her other books include Rock-and-Roll Woman and Bruce Springsteen: An Illustrated Biography.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4533a6b0